module.exports = __webpack_public_path__ + "img/jinrong-bg-4.3618668e.png";